import { useTranslation } from 'react-i18next'
import { useApplicationLocalRights } from 'hooks'
import useSubcomponents from 'useSubcomponents'
import EidTableGrid from 'components/EidTableGrid/EidTableGrid'
import { Box } from '@mui/material'
import { SearchMenuBarFilter } from 'components/WrapperComponents/SearchMenuBar'
import { Filters } from 'components'

export const LocalRights = ({ managementRoleId, queryData }) => {
    const { t } = useTranslation()
    const { getAccessBasedAttributes } = useSubcomponents()
    const attributes = [
        {
            name: 'name',
            label: t('FriendlyName'),
            sortable: true,

            styles: {
                width: '296px',
            },
            //NOTE : Keeping the commented out code for subcomponent traceability
            // requireAccess: {
            //     control:
            //         'ResourceAdmin-ManagementRoleDetails-Overview-LocalRights-FriendlyName',
            // },
        },
        {
            name: 'description',
            label: t('Description'),
            sortable: true,

            styles: {
                width: '290px',
            },
            requireAccess: {
                control:
                    'ResourceAdmin-ManagementRoleDetails-Overview-LocalRights-Description',
            },
        },
        {
            name: 'rightTypeName',
            label: t('RightType'),
            sortable: true,

            styles: {
                width: '160px',
            },
            requireAccess: {
                control:
                    'ResourceAdmin-ManagementRoleDetails-Overview-LocalRights-RightType',
            },
        },
        {
            name: 'resourceSystemName',
            label: t('ResourceSystem'),
            sortable: true,

            styles: {
                width: '160px',
            },
            requireAccess: {
                control:
                    'ResourceAdmin-ManagementRoleDetails-Overview-LocalRights-ResourceSystem',
            },
        },
    ]

    const {
        list: localRights,
        loading: localRightsLoading,
        pagination: localRightsPagination,
    } = useApplicationLocalRights(managementRoleId, Boolean(managementRoleId))

    return (
        <>
            <Box
                width="100%"
                display="flex"
                alignItems="center"
                justifyContent="end"
                padding="1.6rem 3.2rem"
                bgcolor="white"
                borderTop="1px solid #eef0f4"
            >
                <Box style={{ width: '24rem' }}>
                    <SearchMenuBarFilter>
                        <Filters.TextSearch outlined />
                    </SearchMenuBarFilter>
                </Box>
            </Box>
            <EidTableGrid
                noDataMessage={t('NoDataMessage')}
                pagination={localRightsPagination}
                isLoading={localRightsLoading}
                attributes={getAccessBasedAttributes(attributes)}
                list={localRights}
                tableViewOnly
            />
        </>
    )
}
